<script lang="ts" setup>
import { FontAwesomeIcon } from '@shared/plugin/icons';
import VSkeleton from '../VSkeleton/VSkeleton.vue';
import VInfoBox from '../VInfoBox/VInfoBox.vue';

export interface FileDownloadProps {
  download?: boolean;
  loading?: boolean;
  description?: string;
  fileUrl?: string;
  errorMessage?: string;
}

const props = defineProps<FileDownloadProps>();
</script>

<template>
  <VInfoBox v-if="props.errorMessage" class="w-full" type="danger">
    {{ props.errorMessage }}
  </VInfoBox>

  <div v-else class="relative flex rounded-lg border border-grey-200 bg-grey-50 px-6 py-4">
    <VSkeleton v-if="props.loading" />

    <a
      v-else
      class="flex w-full items-center gap-2 text-primary after:absolute after:inset-0"
      :download="props.download ? '' : undefined"
      :href="props.fileUrl"
      :rel="props.download ? undefined : 'noopener noreferrer'"
      :target="props.download ? undefined : '_blank'"
    >
      <FontAwesomeIcon class="text-base" :icon="['fas', 'file-pdf']" />

      <span class="truncate font-bold">
        {{ props.description }}
      </span>

      <FontAwesomeIcon
        class="ml-auto text-base text-primary-900"
        :icon="['far', props.download ? 'download' : 'square-up-right']"
      />
    </a>
  </div>
</template>
